module.exports = __webpack_public_path__ + "static/webBG-f3d16a9bf697c092647f5dd5e9618484.png";